<script>
import { mapActions } from 'vuex'
export default {
  name: 'JoinClanPage',
  mounted() {
    console.log()
    this.joinClan({
      password: this.$route.params.password,
    }).then(() => {
      this.$router.push({
        name: 'my-friends-page',
      })
    })
  },
  methods: {
    ...mapActions({
      joinClan: 'profile/clan/joinExistingClan',
    }),
  },
  render() { return '' },
}
</script>
